import React from "react";
import "../CSS/styles.css";

const Mission = () => {
  return (
    <div className="container-fluid px-lg-5 py-5 px-0 vbg mt-5">
      <div className="row px-lg-5">
        <div className="col-lg-6 p-lg-5">
          <div className="wcc p-5 int">
            <h3 className="mb-0 fw-bold bc">Our Mission</h3>
            <p className="gc mb-0 mt-4 pb-4">Building resilient futures through knowledge & expertise. We strive to empower organizations with the tools, strategies, and capabilities they need to navigate risks and thrive in challenging environments. </p>
          </div>
        </div>
        <div className="col-lg-6 p-lg-5">
          <div className="wcc p-5 int">
            <h3 className="mb-0 fw-bold bc">Our Vision</h3>
            <p className="gc mb-0 mt-4">To be the trusted global partner for risk and crisis management, recognized for our innovative approaches, technical excellence, and commitment to delivering sustainable solutions that create lasting value for our clients. </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Mission